/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-04-06 17:08:40
 * @LastEditTime: 2022-04-18 16:01:51
 * @FilePath: \insurforce-backstage-platform-side\src\views\claim\parameterManage\utils.js
 */
const columns = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  scopedSlots: {
    customRender: 'index'
  },
  width: 80,
  align: 'center'
}, {
  slots: {
    title: '参数名称'
  },
  dataIndex: 'name',
  key: 'name',
  align: 'center'
}, {
  slots: {
    title: '参数代码'
  },
  dataIndex: 'code',
  key: 'code',
  align: 'center'
}, {
  slots: {
    title: '控件'
  },
  dataIndex: 'typeName',
  key: 'typeName',
  align: 'center',
  scopedSlots: {
    customRender: 'typeName'
  }
}, {
  slots: {
    title: '排序'
  },
  dataIndex: 'sort',
  key: 'sort',
  align: 'center'
}, {
  slots: {
    title: '更新时间'
  },
  dataIndex: 'updateAt',
  key: 'updateAt',
  align: 'center'
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'operation',
  key: 'operation',
  align: 'center',
  width: 160,
  scopedSlots: {
    customRender: 'operation'
  }
}];
const pagination = {
  showSizeChanger: true,
  showQuickJumper: true,
  total: 0,
  pageSize: 10,
  // 每页条数
  page: 1,
  current: 1,
  showTotal: total => {
    return `共 ${total} 条`;
  },
  onShowSizeChange: (current, size) => {
    pagination.pageSize = size;
  }
};

// 控件数据
const paramsTypeObj = {
  1: '文本框',
  2: '下拉选项',
  3: '时间插件',
  4: '层级下拉（地区）',
  5: '层级下拉（职业）',
  6: '省市区代码',
  7: '下拉选项（银行）'
};
const ADD_RULES = {
  name: [{
    required: true,
    message: '请输入参数名称',
    trigger: 'blur'
  }, {
    message: '1-50字符',
    max: 50,
    min: 1
  }],
  code: [{
    required: true,
    message: '请输入参数代码',
    trigger: 'blur'
  }, {
    message: '1-200字符',
    max: 200,
    min: 1
  }],
  sort: [{
    required: true,
    message: '请输入排序数',
    trigger: 'blur'
  }],
  type: [{
    required: true,
    message: '请选择控件',
    trigger: 'change'
  }],
  isTag: [{
    required: true,
    message: '请选择是否生成标签',
    trigger: 'change'
  }]
};
export { columns, pagination, paramsTypeObj, ADD_RULES };